// Shared axios instance: adds the login token and refreshes it when it expires (20 min)
import axios from "../../../axios/axiosSetup";
import { BASE_URL } from "../../../configs/WebServiceUrl";

/**
 * Student STEM progress & evaluation, stored in the School Module backend (main_admin_db).
 * The backend takes the student and school from the login token, so only ids/counts are sent.
 */
const STEM_PROGRESS_BASE_URL = `${BASE_URL}/lms/stem-progress`;

const request = async (method, path, data) => {
  try {
    const res = await axios({ method, url: `${STEM_PROGRESS_BASE_URL}${path}`, data });
    if (!res.data?.success) {
      throw new Error(res.data?.message || "STEM progress request failed");
    }
    return res.data.data;
  } catch (err) {
    const message = err.response?.data?.message || err.message || "STEM progress request failed";
    console.error(`[STEM PROGRESS API] ${method} ${path} failed:`, message);
    const error = new Error(message);
    error.status = err.response?.status;
    error.data = err.response?.data?.data;
    throw error;
  }
};

export const stemProgressApi = {
  /** GET /lms/stem-progress/projects/:projectId -> { completed_stages, progress[], evaluations[] } */
  getProjectSummary: (projectId) => request("GET", `/projects/${projectId}`),

  /** POST /lms/stem-progress/stages/:stageId/progress */
  saveStageProgress: (stageId, projectId, isComplete = true) =>
    request("POST", `/stages/${stageId}/progress`, {
      project_id: projectId,
      is_complete: isComplete ? 1 : 0,
    }),

  /** GET /lms/stem-progress/stages/:stageId/evaluation */
  getStageEvaluation: (stageId) => request("GET", `/stages/${stageId}/evaluation`),

  /**
   * POST /lms/stem-progress/stages/:stageId/evaluation (not_attempted is worked out by the backend).
   * Allowed once per stage: a second submit returns 409 with the saved result.
   */
  saveStageEvaluation: (
    stageId,
    projectId,
    { totalQuestions, attempted, correct, wrong, answers, attempts },
  ) =>
    request("POST", `/stages/${stageId}/evaluation`, {
      project_id: projectId,
      total_questions: totalQuestions,
      attempted,
      correct,
      wrong,
      answers,
      attempts,
    }),
};
